import React, { useEffect } from 'react';

import { SocialCarousel } from 'components/social-carousel';
import { SocialsNetworks } from 'enums/social-networks';
import { useInstagramFeed } from 'hooks/use-instagram-feed';

import { CAROUSEL_IMAGE_LIMIT } from './constants';
import { Container } from './styles';

export const InstagramCarouselSection = () => {
  const { images, username, isLoading, refetch } = useInstagramFeed(CAROUSEL_IMAGE_LIMIT);

  // At this moment we don't have any info about the image description
  const imagesData = images.map(({ mediaUrl }) => ({ url: mediaUrl, description: '' }));

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <SocialCarousel
        slidesToShow={3}
        dragging={true}
        images={imagesData}
        accountUsername={username}
        network={SocialsNetworks.Instagram}
        isLoading={isLoading}
      />
    </Container>
  );
};

export default InstagramCarouselSection;
